// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3hyod","errors":"Errors_errors__3anvK"};